import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/LoginPublic.vue";
import RecoverPassword from "../views/RecoverPassword.vue";
import ResetPasswordFirtsTime from "../views/ResetPasswordFirtsTime.vue";
import RegisterPublic from "../views/RegisterPublic.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/recover-password",
    name: "RecoverPassword",
    component: RecoverPassword,
  },
  {
    path: "/reset-password",
    name: "ResetPasswordFirtsTime",
    component: ResetPasswordFirtsTime,
  },
  {
      path: "/register",
      name: "RegisterPublic",
      component: RegisterPublic,
    },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
